export default __webpack_public_path__ + "static/media/acm.88b29bfd.png";